const getImageEntryBackgroundStyle = (entry, additionalStyles = {}) => {
  const url = entry && entry.file.url
  return url ? { backgroundImage: `url('${url}')`, ...additionalStyles } : {}
}

export default getImageEntryBackgroundStyle
